import Phaser from 'phaser';
import { applyTheme } from '../render/themes';
import { makeFruit } from '../render/fruits';
import type { FruitKind } from '../types';

export class StartScene extends Phaser.Scene {
  constructor() {
    super('StartScene');
  }

  create(): void {
    const W = this.scale.width;
    const H = this.scale.height;
    applyTheme(this, 'meadow', H - 120);

    // Sun in the top-left
    const sunX = 130;
    const sunY = 130;
    const halo = this.add.circle(sunX, sunY, 92, 0xffe7a8, 0.35);
    this.add.circle(sunX, sunY, 60, 0xffd24a);
    this.tweens.add({
      targets: [halo],
      scale: 1.1,
      alpha: 0.5,
      duration: 1800,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });

    // Title
    this.add
      .text(W / 2, H / 2 - 120, 'ANIMAL QUEST', {
        fontFamily: 'sans-serif',
        fontSize: '88px',
        color: '#3d2914',
        stroke: '#fff',
        strokeThickness: 6,
      })
      .setOrigin(0.5);

    // Decorative fruit row.
    const fruits: FruitKind[] = ['apple', 'berry', 'melon', 'pear', 'golden_apple', 'banana'];
    const fruitY = H - 80;
    fruits.forEach((kind, i) => {
      const fx = W / 2 + (i - (fruits.length - 1) / 2) * 110;
      const f = makeFruit(this, kind, fx, fruitY);
      f.setScale(1.6);
      this.tweens.add({
        targets: f,
        y: fruitY - 8,
        duration: 700 + i * 60,
        yoyo: true,
        repeat: -1,
        ease: 'Sine.easeInOut',
      });
    });

    // ─── Identical recipe to the title-screen Fullscreen button ───
    // (only the position, size and label differ).
    const startBtn = this.add
      .rectangle(W / 2, H / 2 + 30, 420, 110, 0x6b3aa8)
      .setStrokeStyle(4, 0xffffff)
      .setInteractive({ useHandCursor: true });
    this.add
      .text(W / 2, H / 2 + 30, 'Start', {
        fontFamily: 'sans-serif',
        fontSize: '46px',
        color: '#ffffff',
      })
      .setOrigin(0.5);
    // Phaser docs note: use `pointerup` (not `pointerdown`) to trigger
    // fullscreen — pointerup is dispatched in a way that preserves the
    // user-activation token through to requestFullscreen.
    startBtn.on('pointerup', () => {
      if (!this.scale.isFullscreen) this.scale.startFullscreen();
    });

    // Move on once fullscreen has actually entered.
    this.scale.once('enterfullscreen', () => {
      this.scene.start('TitleScene');
    });
  }
}
